import { render } from "./DefaultDialog.vue?vue&type=template&id=2eaef6fd&ts=true"
import script from "./DefaultDialog.vue?vue&type=script&lang=ts"
export * from "./DefaultDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__